/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { IRecomputeClipTimingData } from './recompute-clip-timing-data';
import { recomputeClipTimingDataSchema } from './recompute-clip-timing-data';

export const recomputeClipTimingResponseSchema = createApiResponseSchema(
  recomputeClipTimingDataSchema,
) as z.ZodSchema<IAPI<IRecomputeClipTimingData>>;

export type IRecomputeClipTimingResponse = IAPI<IRecomputeClipTimingData>;
